import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';
import './user-preferences-page.scss';

function UserPreferencesPage() {
  return (
    <Box
      sx={{
        backgroundColor: 'background.menu',
        height: '100vh',
        display: 'flex',
      }}
    >
      <Box>
        <Outlet />
      </Box>
    </Box>
  );
}

export default UserPreferencesPage;
